export enum Widget {
  LeaderboardToggle = 'leaderboardToggle',
  RewardToggle = 'rewardToggle',
  HabitsViewToggle = 'habitsViewToggle',
  CovidLearningLossReport = 'covidLearningLossReport'
}
